<template>

    <div class="p-8 text-theme-main leading-loose">
        <p>
            MIX_AWS_LEGACY_MEDIA: {{ a }}<br />
            MIX_CLOUDFRONT_DNSNAME: {{ b }}<br />
            MIX_LEGACY_CLOUDFRONT_DNSNAME: {{ c }}<br />
        </p>
    </div>

</template>

<script>

    export default {

        data() {
            return {
                a: process.env.MIX_AWS_LEGACY_MEDIA,
                b: process.env.MIX_CLOUDFRONT_DNSNAME,
                c: process.env.MIX_LEGACY_CLOUDFRONT_DNSNAME
            }
        }

    }

</script>
